import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { AmenitiesTableconstant } from "./AmenitiesTableConstant";

const initialState = {
  AmenitiesTableList: [],
  AmenitiesTable: {
    isLoading: false,
  },
  postAmenitiesList: [{}],
  postAmenities: {
    isLoading: false,
  },

  UpdateAmenitiesList: [],
  UpdateAmenities: {
    isLoading: false,
  },
  AmenitiesEnableDisableList: [],
};

export const AmenitiesTableReducer = persistReducer(
  {
    storage,
    key: "AmenitiesTable",
    whitelist: ["AmenitiesTableList"],
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      case AmenitiesTableconstant.AMENITIES_TABLE_REQUEST: {
        return {
          ...state,
          AmenitiesTableList: [],
          AmenitiesTable: {
            isLoading: true,
          },
        };
      }

      case AmenitiesTableconstant.AMENITIES_TABLE_RESPONSE: {
        return {
          ...state,
          AmenitiesTableList: payload,
          AmenitiesTable: {
            isLoading: false,
          },
        };
      }
      // ****************post_api**********

      case AmenitiesTableconstant.POST_AMENITIES_REQUEST: {
        return {
          ...state,
          postAmenitiesList: [],
          postAmenities: {
            isLoading: true,
          },
        };
      }

      case AmenitiesTableconstant.POST_AMENITIES_RESPONSE: {
        return {
          ...state,
          postAmenitiesList: payload,
          postAmenities: {
            isLoading: false,
          },
        };
      }

      //enable desable reducer

      case AmenitiesTableconstant.ENABLE_DESABLE_AMENITIES_REQUEST: {
        return {
          ...state,
          AmenitiesEnableDisableList: [],
          AmenitiesEnableTable: {
            isLoading: true,
          },
        };
      }
      case AmenitiesTableconstant.ENABLE_DESABLE_AMENITIES_RESPONSE: {
        return {
          ...state,
          AmenitiesEnableDisableList: payload,
          AmenitiesEnableTable: {
            isLoading: false,
          },
        };
      }

      case AmenitiesTableconstant.UPDATE_AMENITIES_REQUEST: {
        return {
          ...state,
          UpdateAmenitiesList: [],
          UpdateAmenities: {
            isLoading: true,
          },
        };
      }

      case AmenitiesTableconstant.UPDATE_AMENITIES_RESPONSE: {
        return {
          ...state,
          UpdateAmenitiesList: payload,
          UpdateAmenities: {
            isLoading: false,
          },
        };
      }

      default:
        return state;
    }
  }
);
